class CartRemoveButton2 extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();
      const item = this.closest(".cart-notification-product");
      const cartNotification = this.closest("cart-notification");
      const scrollContainer = cartNotification?.querySelector('#min-cart-items');
      const scrollTop = scrollContainer?.scrollTop || 0;
      this.querySelector('button')?.blur();
      item.classList.add("is-removing");
      cartNotification.lockScrollPosition(scrollContainer, scrollTop);
      cartNotification.updateQuantity(this.dataset.index, 0);
    });
  }
}
customElements.define("cart-remove-button-2", CartRemoveButton2);

class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById("offcanvas__mini_cart");
    this.pendingScrollTop = null;
    this.scrollLockFrame = 0;
    this.refreshReferences();
    this.syncUpsellVisibility();

    this.header = document.querySelector("sticky-header");
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );

    this.querySelector(
      'button[type="button"].cart-notification__close'
    ).addEventListener("click", this.close.bind(this));

    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0
    );

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener("change", this.debouncedOnChange.bind(this));
  }

  refreshReferences() {
    this.cartItemConatiner = this.querySelector("#cart-notification-product");
    this.emptyCartItem = this.querySelector("#min-cart-items");
    this.cartItemMessageShow = this.querySelector(".empty__cart__item");
    this.emptyCartButtonDisable = this.querySelector("#empty__cart__button");
    this.cartAddSuccess = this.querySelector(".item__success_message");
    this.cartEmptyHead = this.querySelector(".item__empty_message");
  }

  syncUpsellVisibility() {
    const upsells = this.querySelector('[data-sv-cart-upsells]');
    if (!upsells) return;

    const cartProductIds = new Set(
      Array.from(this.querySelectorAll('#cart-notification-product [data-product-id]'))
        .map((item) => item.dataset.productId)
        .filter(Boolean)
    );
    const upsellCards = Array.from(
      upsells.querySelectorAll('[data-sv-cart-upsell-product-id]')
    );

    upsellCards.forEach((card) => {
      card.hidden = cartProductIds.has(card.dataset.svCartUpsellProductId);
    });
    upsells.hidden = !upsellCards.some((card) => !card.hidden);
  }

  lockScrollPosition(scrollContainer, scrollTop) {
    if (!scrollContainer) return;
    this.releaseScrollPosition();
    this.pendingScrollTop = scrollTop;
    const maintainScrollPosition = () => {
      if (this.pendingScrollTop === null || !scrollContainer.isConnected) return;
      scrollContainer.scrollTop = this.pendingScrollTop;
      this.scrollLockFrame = requestAnimationFrame(maintainScrollPosition);
    };
    maintainScrollPosition();
  }

  releaseScrollPosition() {
    if (this.scrollLockFrame) cancelAnimationFrame(this.scrollLockFrame);
    this.scrollLockFrame = 0;
    this.pendingScrollTop = null;
  }

  onChange(event) {
    if (!event.target.closest("select")) {
      this.updateQuantity(
        event.target.dataset.index,
        event.target.value,
        document.activeElement.getAttribute("name"),
        event.target.dataset.quantityVariantId
      );
      // document
      //   .querySelector(".cart_action_drawer_overlay")
      //   .classList.add("active");
    }
  }

  open() {
    this.loadAcceleratedCheckout();
    this.notification.classList.add("animate", "active");
    document.querySelector("body").classList.add("added__overlay");

    this.notification.addEventListener(
      "transitionend",
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener("click", this.onBodyClick);
  }

  close() {
    document.getElementById("offcanvas__mini_cart").classList.remove("active");
    document.querySelector("body").classList.remove("added__overlay");

    document.body.removeEventListener("click", this.onBodyClick);

    //removeTrapFocus(document.querySelector(".header__actions_btn--cart"));
  }

  loadAcceleratedCheckout() {
    const template = this.querySelector('template[data-sv-cart-payments]');
    if (!template || this.querySelector('#empty__cart__button')?.classList.contains('no-js-inline')) return;
    template.replaceWith(document.importNode(template.content, true));
  }

  renderContents(parsedState) {
    const scrollContainer = this.querySelector('#min-cart-items');
    const scrollTop = Number.isFinite(this.pendingScrollTop)
      ? this.pendingScrollTop
      : (scrollContainer ? scrollContainer.scrollTop : 0);
    if (scrollContainer && this.pendingBodyHeight) {
      scrollContainer.style.minHeight = `${this.pendingBodyHeight}px`;
    }
    this.getSectionsToRender().forEach((section) => {
      const elementToReplace = document.getElementById(section.id);
      const sectionMarkup = this.getSectionInnerHTML(parsedState.sections?.[section.id]);
      if (elementToReplace && sectionMarkup !== null) {
        elementToReplace.innerHTML = sectionMarkup;
      }
    });

    this.refreshReferences();
    this.syncUpsellVisibility();
    const renderedItemCount = Array.from(
      this.querySelectorAll('#cart-notification-product [name="updates[]"]')
    ).reduce((total, quantityInput) => {
      const quantity = Number.parseInt(quantityInput.value, 10);
      return total + (Number.isFinite(quantity) ? quantity : 0);
    }, 0);
    const itemCount = Number.isFinite(Number(parsedState.item_count))
      ? Number(parsedState.item_count)
      : renderedItemCount;

    // Toggle Class
    this.emptyCartItem?.classList.toggle(
      "no-js-inline",
      itemCount === 0
    );

    if (itemCount === 0) {
      this.emptyCartItem?.classList.add("no-js-inline");
      this.emptyCartButtonDisable?.classList.add("no-js-inline");
      this.cartItemMessageShow?.classList.remove("no-js-inline");
      this.cartAddSuccess?.classList.add("no-js-inline");
      this.cartEmptyHead?.classList.remove("no-js-inline");
    } else {
      this.emptyCartItem?.classList.remove("no-js-inline");
      this.emptyCartButtonDisable?.classList.remove("no-js-inline");
      this.cartItemMessageShow?.classList.add("no-js-inline");
      this.cartAddSuccess?.classList.remove("no-js-inline");
      this.cartEmptyHead?.classList.add("no-js-inline");
    }

    const drawerCount = this.querySelector('[data-sv-cart-drawer-count]');
    if (drawerCount) {
      const singular = drawerCount.dataset.singular || 'item';
      const plural = drawerCount.dataset.plural || 'items';
      drawerCount.hidden = itemCount === 0;
      drawerCount.textContent = `${itemCount} ${itemCount === 1 ? singular : plural}`;
    }

    if (this.header) this.header.reveal();
    this.loadAcceleratedCheckout();
    if (!this.notification.classList.contains('active')) this.open();
    requestAnimationFrame(() => {
      const updatedScrollContainer = this.querySelector('#min-cart-items');
      if (updatedScrollContainer) {
        updatedScrollContainer.scrollTop = scrollTop;
        updatedScrollContainer.style.minHeight = this.pendingBodyHeight ? `${this.pendingBodyHeight}px` : '';
        window.setTimeout(() => {
          updatedScrollContainer.style.minHeight = '';
          this.notification.classList.remove('is-updating');
          this.releaseScrollPosition();
        }, 260);
      } else {
        this.notification.classList.remove('is-updating');
        this.releaseScrollPosition();
      }
      this.pendingBodyHeight = 0;
    });
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-notification-product",
      },
      {
        id: "cart-notification-subtotal",
      },
      {
        id: "cart-notification-count",
      },
      {
        id: "cart-notification-discount",
      },
    ];
  }

  async refreshFromServer() {
    const sectionIds = this.getSectionsToRender().map((section) => section.id);
    const sectionUrl = new URL(window.location.href);
    const shopRoot = window.Shopify?.routes?.root || '/';
    sectionUrl.hash = '';
    sectionUrl.searchParams.set('sections', sectionIds.join(','));

    const [sectionsResponse, cartResponse] = await Promise.all([
      fetch(sectionUrl.toString(), {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      }),
      fetch(`${shopRoot}cart.js`, {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      }),
    ]);

    if (!sectionsResponse.ok || !cartResponse.ok) {
      throw new Error('Unable to refresh the cart drawer.');
    }

    const [sections, cart] = await Promise.all([
      sectionsResponse.json(),
      cartResponse.json(),
    ]);

    const refreshedState = { ...cart, sections };
    this.renderContents(refreshedState);
    return refreshedState;
  }

  updateQuantity(line, quantity, name, variantId) {
    const currentBody = this.querySelector('#min-cart-items');
    this.pendingBodyHeight = currentBody?.offsetHeight || 0;
    this.notification.classList.add('is-updating');
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then(async (state) => {
        let parsedState = JSON.parse(state);
        const quantityElement = document.getElementById(`Quantity-${line}`);
        const items = document.querySelectorAll(".cart-notification-product");

        if (parsedState.errors) {
          if (quantityElement) quantityElement.value = quantityElement.getAttribute("value");
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        const hasCartSections = this.getSectionsToRender()
          .some((section) => typeof parsedState.sections?.[section.id] === "string");

        if (hasCartSections) {
          this.renderContents(parsedState);
        } else {
          parsedState = await this.refreshFromServer();
        }

        const updatedValue = parsedState.items[line - 1]
          ? parsedState.items[line - 1].quantity
          : undefined;
        let message = "";
        if (
          items.length === parsedState.items.length &&
          quantityElement && updatedValue !== parseInt(quantityElement.value)
        ) {
          if (typeof updatedValue === "undefined") {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace(
              "[quantity]",
              updatedValue
            );
          }
        }
        this.updateLiveRegions(line, message);

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "cart-notification",
          cartData: parsedState,
          variantId: variantId,
        });
      })
      .catch((error) => {
        if (currentBody) currentBody.style.minHeight = '';
        this.notification.classList.remove('is-updating');
        this.releaseScrollPosition();
        console.error('Unable to update the cart drawer.', error);
        // const errors =
        //   document.getElementById("cart-errors") ||
        //   document.getElementById("CartDrawer-CartErrors");
        // errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        // this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError = document.getElementById(`Line-item-error-${line}`);
    if (lineItemError) {
      lineItemError.classList.remove("d-none");
      lineItemError.querySelector(".cart-item__error-text").innerHTML = message;
    }
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    if (typeof html !== 'string') return null;
    const documentFragment = new DOMParser().parseFromString(html, "text/html");
    const section = documentFragment.querySelector(selector);
    return section ? section.innerHTML : documentFragment.body.innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (
      target !== this.notification &&
      !target.closest("cart-notification") &&
      !target.closest("#quickViewWrapper")
    ) {
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-notification", CartNotification);

class OpenMiniCart extends HTMLElement {
  constructor() {
    super();

    this.cartButton = this.querySelector("a");

    this.cartButton.addEventListener("click", (event) => {
      event.preventDefault();
      this.onClickMiniCart();
    });

    this.notification = document.getElementById("offcanvas__mini_cart");
    this.onBodyClassRemove = this.handleBodyClass.bind(this);

    this.notification.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.miniCartClose()
    );
  }

  onClickMiniCart() {
    document.querySelector('cart-notification')?.loadAcceleratedCheckout();
    document
      .getElementById("offcanvas__mini_cart")
      .classList.add("animate", "active");
    document.querySelector("body").classList.add("added__overlay");

    this.notification.addEventListener(
      "transitionend",
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener("click", this.onBodyClassRemove);
  }

  miniCartClose() {
    document.getElementById("offcanvas__mini_cart").classList.remove("active");
    document.querySelector("body").classList.remove("added__overlay");

    document.body.removeEventListener("click", this.onBodyClassRemove);
  }

  handleBodyClass(evt) {
    let eventTarget = evt.target;
    if (
      !eventTarget.closest("cart-notification") &&
      !eventTarget.closest("open-minicart") &&
      !eventTarget.closest("button")
    ) {
      this.miniCartClose();
    }
  }
}
customElements.define("open-minicart", OpenMiniCart);
